import { put, take, race } from "redux-saga/effects";
import {
  UPDATE_ACTIVE_SITE,
  UPDATE_SELECTED_SITES,
  UPDATE_DAYS_RANGE,
} from "./selections";
import { LOAD_BETA_ISSUES_REQUEST_SUCCESS } from "./issues";
import { ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS } from "./actionsUI";
import { LOAD_REPORT_DATA_SUCCESS } from "../monthlySummary/actionTypes";
import { LOAD_MONITORING_REQUEST_SUCCESS } from "../monitoring/actionTypes";
import {
  SAVE_ACTION_REQUEST_SUCCESS,
  ADD_ACTION_REQUEST_SUCCESS,
} from "../action/actionTypes";
import { ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS } from "./associate";

export const UPDATE_SHOULD_REQUEST_INSIGHTS =
  "bonfire/_BETA/requestSchedule/UPDATE_SHOULD_REQUEST_INSIGHTS";
export const UPDATE_SHOULD_REQUEST_MONITORING =
  "bonfire/_BETA/requestSchedule/UPDATE_SHOULD_REQUEST_MONITORING";
export const UPDATE_SHOULD_REQUEST_ISSUES =
  "bonfire/_BETA/requestSchedule/UPDATE_SHOULD_REQUEST_ISSUES";
export const UPDATE_SHOULD_REQUEST_MONTHLY_SUMMARY =
  "bonfire/_BETA/requestSchedule/UPDATE_SHOULD_REQUEST_MONTHLY_SUMMARY";

const INITIAL_STATE = {
  shouldRequestInsights: true,
  shouldRequestMonitoring: true,
  shouldRequestIssues: true,
  shouldRequestMonthlySummary: true,
};

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_SHOULD_REQUEST_INSIGHTS:
      return {
        ...state,
        shouldRequestInsights: action.shouldRequestInsights,
      };
    case UPDATE_SHOULD_REQUEST_MONITORING:
      return {
        ...state,
        shouldRequestMonitoring: action.shouldRequestMonitoring,
      };
    case UPDATE_SHOULD_REQUEST_ISSUES:
      return {
        ...state,
        shouldRequestIssues: action.shouldRequestIssues,
      };
    case UPDATE_SHOULD_REQUEST_MONTHLY_SUMMARY:
      return {
        ...state,
        shouldRequestMonthlySummary: action.shouldRequestMonthlySummary,
      };
    default:
      return state;
  }
}

export const setShouldRequestIssues = (shouldRequestIssues) => ({
  type: UPDATE_SHOULD_REQUEST_ISSUES,
  shouldRequestIssues,
});
export const setShouldRequestInsights = (shouldRequestInsights) => ({
  type: UPDATE_SHOULD_REQUEST_INSIGHTS,
  shouldRequestInsights,
});
export const setShouldRequestMonitoring = (shouldRequestMonitoring) => ({
  type: UPDATE_SHOULD_REQUEST_MONITORING,
  shouldRequestMonitoring,
});
export const setShouldRequestMonthlySummary = (
  shouldRequestMonthlySummary
) => ({
  type: UPDATE_SHOULD_REQUEST_MONTHLY_SUMMARY,
  shouldRequestMonthlySummary,
});

// Selectors
export const getShouldRequestIssues = (state) =>
  state.requestSchedule.shouldRequestIssues;
export const getShouldRequestInsights = (state) =>
  state.requestSchedule.shouldRequestInsights;
export const getShouldRequestMonitoring = (state) =>
  state.requestSchedule.shouldRequestMonitoring;

// Sagas
export function* shouldRequestIssuesFlow() {
  while (true) {
    yield race({
      siteChanged: take(UPDATE_SELECTED_SITES),
      actionChanged: take(SAVE_ACTION_REQUEST_SUCCESS),
      actionAdded: take(ADD_ACTION_REQUEST_SUCCESS),
      includeOpenStatusChanged: take(ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS),
    });

    yield put(setShouldRequestIssues(true));

    yield take(LOAD_BETA_ISSUES_REQUEST_SUCCESS);

    yield put(setShouldRequestIssues(false));
  }
}

export function* shouldRequestInsightsFlow() {
  while (true) {
    yield race({
      equipAssociated: take(ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS),
      siteChanged: take(UPDATE_SELECTED_SITES),
      daysRangeChanged: take(UPDATE_DAYS_RANGE),
    });

    yield put(setShouldRequestInsights(true));
  }
}

export function* shouldRequestMonitoringFlow() {
  while (true) {
    yield race({
      equipAssociated: take(ASSOCIATE_RULE_EQUIP_REQUEST_SUCCESS),
      siteChanged: take(UPDATE_SELECTED_SITES),
      daysRangeChanged: take(UPDATE_DAYS_RANGE),
    });

    yield put(setShouldRequestMonitoring(true));
    yield take(LOAD_MONITORING_REQUEST_SUCCESS);
    yield put(setShouldRequestMonitoring(false));
  }
}

export function* shouldRequestMonthlySummaryFlow() {
  while (true) {
    yield take(UPDATE_ACTIVE_SITE);

    yield put(setShouldRequestMonthlySummary(true));

    yield take(LOAD_REPORT_DATA_SUCCESS);

    yield put(setShouldRequestMonthlySummary(false));
  }
}
